import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router';
import { InvoiceRecognizerLoader } from '../helpers/ai/InvoiceRecognizer/InvoiceRecognizerLoader';
import { InvoiceRecognizerViewer } from '../helpers/ai/InvoiceRecognizer/InvoiceRecognizerViewer';
import { AI_UTILITIES } from '../constants/aiUtilities';
import { useTheme } from '../components/hooks/useTheme';
import './Shared.css';

export const InvoiceRecognizer = () => {
    const { theme } = useTheme();

    const icon = theme === 'light' ? AI_UTILITIES.INVOICE_RECOGNIZER.lightIcon : AI_UTILITIES.INVOICE_RECOGNIZER.darkIcon;

    return (
        <div>
            <Helmet>
                <title>{AI_UTILITIES.INVOICE_RECOGNIZER.name}</title>
            </Helmet>
            <div className="d-flex flex-row align-items-center mb-3">
                <img src={icon} alt="Логотип" className='title-icon mr-3' />
                <h4>{AI_UTILITIES.INVOICE_RECOGNIZER.name}</h4>
            </div>            
            <Switch>
                <Route exact path={AI_UTILITIES.INVOICE_RECOGNIZER.path} component={InvoiceRecognizerLoader} />
                <Route path={`${AI_UTILITIES.INVOICE_RECOGNIZER.path}/:inputIdentifier`} component={InvoiceRecognizerViewer} />
            </Switch>
        </div>
    );
};

InvoiceRecognizer.displayName = 'InvoiceRecognizer';